export const HISTORY_PAGE_SIZE = 50;

export function getHistoryPeriodFromTo(timeFilter) {
    const now = new Date();
    const toToday = now.toISOString().slice(0, 10);
    let from = '';
    let to = '';
    switch (timeFilter) {
        case 'week': {
            const d = new Date(now);
            d.setDate(d.getDate() - 7);
            from = d.toISOString().slice(0, 10);
            to = toToday;
            break;
        }
        case 'month': {
            const d = new Date(now);
            d.setDate(d.getDate() - 30);
            from = d.toISOString().slice(0, 10);
            to = toToday;
            break;
        }
        case '3months': {
            const d = new Date(now);
            d.setDate(d.getDate() - 90);
            from = d.toISOString().slice(0, 10);
            to = toToday;
            break;
        }
        case 'all':
        default:
            break;
    }
    return { from, to };
}

export function formatWorkoutDuration(seconds) {
    if (!seconds || seconds <= 0) return null;
    const totalMin = Math.floor(seconds / 60);
    if (totalMin >= 60) {
        return `${Math.floor(totalMin / 60)}h ${totalMin % 60}m`;
    }
    return `${totalMin} min`;
}
